import React from "react";
import ToggleCollapseView from "@src/features/zones/components/toggle-collapse-view";
import { ZoneList } from '@src/features/zones/pages/zones-page/components/ZoneList';
import { ZoneEntity, ZoneType } from "@src/core/features";

interface PermanentSectionsProps {
    zones: ZoneEntity[];
}

export const PermanentSections: React.FC<PermanentSectionsProps> = (props) => {
  const { zones } = props;
  return (
    <React.Fragment >        
      <ToggleCollapseView 
        count={zones.length}
        zoneType={ZoneType.PERMANENT}>
        <ZoneList zones={zones} />     
      </ToggleCollapseView>        
    </React.Fragment>
  );
};